<template>
    <div class="wiper">
        <div id="scroll" class="scroll" @mouseover="mouseover" @mouseout="mouseout" :style="{transform: `translateX(-${stSrcollNum}px)`}">
            <div ref="scrollCont" style="display:flex">
                <div class="itemList" v-for="(item, index) in data" :key="'last'+index">
                    <img :src="item.image[0].url" alt="">
                    <div class="infoCont">
                        <div class="name">{{item.subTitle}}</div>
                        <div class="des">{{item.desc}}</div>
                        <div class="but" @click="goDetails(item)">查看作品</div>
                    </div>
                </div>
                <div class="itemList" v-for="(item, index) in data" :key="'lastda'+index">
                    <img :src="item.image[0].url" alt="">
                    <div class="infoCont">
                        <div class="name">{{item.subTitle}}</div>
                        <div class="des">{{item.desc}}</div>
                        <div class="but" @click="goDetails(item)">查看作品</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name:'wiper',
    props: ['data', 'speed'],
    data(){
        return {
            scrollWidth:0,
            stSrcollNum:0,
            timer: null
        }
    },
    mounted() {
       this.rollHandle()
    },
    methods:{
        rollHandle(){
            this.timer = setInterval(() => {
                this.stSrcollNum += 0.6 
                const dom = this.$refs.scrollCont
                if(dom) {
                    this.scrollWidth = dom.offsetWidth
                }
                if (this.stSrcollNum >= this.scrollWidth / 2){
                    this.stSrcollNum = 0
                }
            }, 1 * (10-this.speed));
        },
        // 点击跳转到项目详情 
        goDetails(item) {
            if(item.url == null ){
                this.$emit('openBigImg', item)
                return false
            }
            window.open(item.url, "_blank");
        },
        mouseover(){
            clearInterval(this.timer)
        },
        mouseout(){
            this.rollHandle()
        }
    },
    beforeDestroy(){
        clearInterval(this.timer)
    }
}
</script>
<style lang="scss" scoped>
.wiper{
    .scroll{
        display: flex;
        width:100%;
        .itemList{
        position: relative;
        padding:0px;
        height: 326px;
            img{
                height: 326px;
            }
            .infoCont{
                opacity: 0;
                text-align: center;
                position: absolute;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-content: center;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.5);
                top: 0;
                left: 0;
                font-family: PingFangSC-Regular;
                font-weight: Regular;
                .name{
                    height: 30px;
                    font-family: PingFangSC-Semibold;
                    font-weight: Semibold;
                    font-size: 28px;
                    color: #FFFFFF;
                }
                .des{
                    height: 22px;
                    font-family: PingFangSC-Regular;
                    font-weight: Regular;
                    font-size: 16px;
                    color: #FFFFFF;
                    margin: 16px 0 25px 0;
                }
                .but{
                    position: relative;
                    margin: 0 auto;
                    width: 124px;
                    line-height: 41px;
                    background: #FF3366;
                    box-shadow: 0 0 28px 0 rgba(83,133,222,0.17);
                    border-radius: 23px;
                    font-size: 16px;
                    color: #FFFFFF;
                    cursor: pointer;
                }
            }
             &:hover .infoCont{
                animation: topShow 500ms forwards;
            }
        }
    }  
    @keyframes topShow {
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
  }
}
</style>